module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_5012.7b907ba3.png";